import { API_BASE_URL } from "../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import SerialProductDetails from "../components/SerialProductDetails";

export default function SerialDetails() {
  const { serialNo } = useParams();
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchDetails = async () => {
      try {
        const response = await axios.get(API_BASE_URL + `/api/visits/serial/${encodeURIComponent(serialNo || "")}`);
        if (mounted) {
          setDetails(response.data || null);
        }
      } catch (error) {
        if (mounted) {
          setDetails(null);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchDetails();

    return () => {
      mounted = false;
    };
  }, [serialNo]);

  if (loading) {
    return <div className="min-h-screen bg-slate-100 px-4 py-10 text-center text-slate-600">Loading serial details...</div>;
  }

  if (!details?.product) {
    return (
      <div className="min-h-screen bg-slate-100 px-4 py-10">
        <div className="mx-auto max-w-3xl rounded-[28px] border border-slate-200 bg-white p-8 text-center shadow-sm">
          <h1 className="text-2xl font-bold text-slate-900">Serial Number Not Found</h1>
          <p className="mt-3 text-sm text-slate-500">
            We could not find product details for serial no {serialNo || "-"}.
          </p>
        </div>
      </div>
    );
  }

  const productName = details.product.productName || details.product.product || "Product";

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,_rgba(241,245,249,1),_rgba(248,250,252,1),_rgba(255,255,255,1))] px-4 py-8">
      <div className="mx-auto max-w-5xl space-y-6">
        {/* Genmech Service Logo */}
        <div className="flex justify-center items-center py-6 px-4 bg-white rounded-[28px] border border-slate-200 shadow-sm transition-all duration-300 hover:shadow-md">
          <img 
            src="/logo-genmech.png" 
            alt="Genmech Service" 
            className="max-h-20 w-auto object-contain sm:max-h-24 md:max-h-28 transition-transform duration-300 hover:scale-[1.03]"
          />
        </div>

        <section className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
          <p className="text-sm font-semibold uppercase tracking-[0.22em] text-sky-700">Serial Details</p>
          <h1 className="mt-2 text-3xl font-bold text-slate-900">{productName}</h1>
          <p className="mt-2 text-sm text-slate-500">
            Public product details for serial no: {details.product.serialNo || serialNo || "-"}
          </p>
        </section>

        <section className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
          <SerialProductDetails
            product={details.product}
            visit={{
              ...details.visit,
              complaintId: details.complaint?.complaintId || ""
            }}
            complaint={details.complaint}
            showVisitDetails={false}
          />
        </section>
      </div>
    </div>
  );
}


